/* Vectra Industries — minimal theme JS */
(function () {
  /* Product page: keep the buy button in step with the selected variant */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var selects = form.querySelectorAll('[data-option]');
    if (!selects.length) return;
    var variants = JSON.parse(form.querySelector('[data-variants]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');

    function sync() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) { btn.disabled = true; btn.querySelector('span').textContent = 'Unavailable'; return; }
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      btn.disabled = !match.available;
      btn.querySelector('span').textContent = match.available ? btn.dataset.add : 'Sold out';
    }
    selects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  });
})();

/* Drawer nav */
(function () {
  var drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;
  var opener = document.querySelector('[data-drawer-open]');

  /* iOS Safari ignores body{overflow:hidden}, and can leave the page stuck
     afterwards. Pinning the body and restoring the scroll position works
     everywhere. */
  var savedY = 0;

  function open() {
    savedY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    drawer.classList.add('open');
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function close() {
    drawer.classList.remove('open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedY);
  }

  if (opener) opener.addEventListener('click', open);
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { close(); });
  });
})();

/* Hero slideshow */
(function () {
  var hero = document.querySelector('[data-hero]');
  if (!hero) return;

  var slides = [].slice.call(hero.querySelectorAll('[data-slide]'));
  if (slides.length < 2) return;

  var dots = [].slice.call(hero.querySelectorAll('[data-hero-dot]'));
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wait = (parseInt(hero.dataset.interval, 10) || 6) * 1000;
  var auto = hero.dataset.autoplay !== 'false' && !reduced;
  var i = 0, timer = null;

  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, x) { s.classList.toggle('is-active', x === i); });
    dots.forEach(function (d, x) {
      d.classList.toggle('is-active', x === i);
      d.setAttribute('aria-selected', x === i ? 'true' : 'false');
    });
  }
  function next() { show(i + 1); }
  function prev() { show(i - 1); }
  function start() { if (auto) { stop(); timer = setInterval(next, wait); } }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function go(n) { show(n); start(); }

  var nextBtn = hero.querySelector('[data-hero-next]');
  var prevBtn = hero.querySelector('[data-hero-prev]');
  if (nextBtn) nextBtn.addEventListener('click', function () { go(i + 1); });
  if (prevBtn) prevBtn.addEventListener('click', function () { go(i - 1); });
  dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.heroDot); }); });

  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

  /* swipe on touch */
  var x0 = null;
  hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
  hero.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 45) { dx < 0 ? next() : prev(); }
    x0 = null; start();
  }, { passive: true });

  show(0);
  start();
})();

/* Reveal on scroll.
   The hidden state is only applied once this script runs, so if JS fails the
   page still renders everything normally. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var groups = [
    '.sec__head', '.tier', '.tile', '.cat', '.feat', '.step',
    '.gal figure', '.card', '.cfg__step', '.loc', '.ftr__grid > *',
    '.band .wrap > *', '.pdp__media > *', '.rte > *'
  ];

  var seen = [];
  groups.forEach(function (sel) {
    var nodes = [].slice.call(document.querySelectorAll(sel));
    /* never touch anything inside the hero, it has its own entrance */
    nodes = nodes.filter(function (n) { return !n.closest('.hero') && seen.indexOf(n) < 0; });

    /* stagger within each parent so rows cascade */
    var byParent = {};
    nodes.forEach(function (n) {
      var key = n.parentElement ? (n.parentElement.dataset.revealKey || (n.parentElement.dataset.revealKey = Math.random().toString(36).slice(2, 8))) : 'x';
      (byParent[key] = byParent[key] || []).push(n);
    });

    Object.keys(byParent).forEach(function (k) {
      byParent[k].forEach(function (n, i) {
        n.setAttribute('data-reveal', '');
        n.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        seen.push(n);
      });
    });
  });

  if (!seen.length) return;
  document.documentElement.classList.add('js-reveal');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  seen.forEach(function (n) { io.observe(n); });
})();

/* Desktop: clicking a nav parent opens its dropdown instead of navigating */
(function () {
  var items = [].slice.call(document.querySelectorAll('.nav__item'));
  if (!items.length) return;
  var desktop = window.matchMedia('(min-width: 1081px), (pointer: coarse)');

  function closeAll(except) {
    items.forEach(function (it) {
      if (it === except) return;
      it.classList.remove('is-open');
      var t = it.querySelector('.nav__top');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  items.forEach(function (item) {
    var top = item.querySelector('.nav__top');
    if (!top) return;
    top.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      /* second click follows the link through */
      if (item.classList.contains('is-open')) return;
      e.preventDefault();
      closeAll(item);
      item.classList.add('is-open');
      top.setAttribute('aria-expanded', 'true');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();

/* Build & price configurator */
(function () {
  var root = document.querySelector('[data-cfg]');
  if (!root) return;

  var sym = root.dataset.currency || '$';
  var list = root.querySelector('[data-cfg-list]');
  /* the sticky mobile bar lives outside .cfg, so search the whole section */
  var scope = root.closest('section') || document;
  var totalEls = [].slice.call(scope.querySelectorAll('[data-cfg-total]'));
  var body = root.querySelector('[data-cfg-body]');
  var baseEl = root.querySelector('[data-base-price]');
  var basePrice = baseEl ? (parseFloat(baseEl.dataset.basePrice) || 0) : 0;
  var baseName = (root.querySelector('.cfg__base-name') || {}).textContent || 'Base tray';

  var boxes = [].slice.call(root.querySelectorAll('input[type="checkbox"][data-price]'));
  var selects = [].slice.call(root.querySelectorAll('select[data-price-select]'));

  function fmt(n) { return sym + Number(n).toLocaleString('en-AU'); }

  function update() {
    var lines = [{ name: baseName.trim(), price: basePrice }];
    var total = basePrice;

    selects.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var p = parseFloat(opt.dataset.price) || 0;
      if (p <= 0) return;             /* "No canopy" and "supply only" add nothing */
      total += p;
      lines.push({ name: opt.value, price: p });
    });

    boxes.forEach(function (i) {
      if (!i.checked) return;
      var p = parseFloat(i.dataset.price) || 0;
      total += p;
      lines.push({ name: i.value, price: p });
    });

    list.innerHTML = lines.map(function (l) {
      return '<li><span>' + l.name + '</span><span>' + (l.price ? fmt(l.price) : 'Incl.') + '</span></li>';
    }).join('');

    totalEls.forEach(function (el) { el.textContent = fmt(total); });

    if (body) {
      body.value = 'BUILD REQUEST\n\n' +
        lines.map(function (l) { return '- ' + l.name + ' — ' + (l.price ? fmt(l.price) : 'included'); }).join('\n') +
        '\n\nEstimated total: ' + fmt(total) + ' inc GST';
    }
  }

  boxes.forEach(function (i) { i.addEventListener('change', update); });
  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
})();
